import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { IDiagramsGraphResponse } from "../models/IDiagramsGraphResponse";
import { IHopexCredentials } from "../models/IHopexCredentials";

const apiITPM = 'HOPEXGraphQL/api/ITPM';
export default class HopexApi {
  // Return base configuration with authentication
  private static getBaseConfig(credentials: IHopexCredentials): AxiosRequestConfig {
    let config: AxiosRequestConfig = {};

    if (credentials.authenticationMethod === 'api') {
      config = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": credentials.apiKey,
        },
      };
    } else {
      const authBasicValue = btoa(`${credentials.username}:${credentials.password}`);
      config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Basic ${authBasicValue}`,
        },
      };
    }
    return config;
  }

  // Get HOPEX context
  public static getContext = (
    credentials: IHopexCredentials
  ): Promise<AxiosResponse<IDiagramsGraphResponse>> => {
    const url = `${credentials.serverUrl}${(!credentials.serverUrl.endsWith('/') ? '/' : '')}${apiITPM}`;
    const graphQuery = {
      query: `{
    _currentContext {
        currencyCode
        currencyId
        databaseId
        databaseLanguage
        databaseLanguageId
        databaseLanguageName
        language
        languageId
        languageName
        libraryId
        profileId
        systemLanguage
        systemLanguageId
        systemLanguageName
        userId
        workingEnvironment
        workingEnvironmentEntryPoint
        workingEnvironmentGroup
        workingEnvironmentGroupTemplate
        workingEnvironmentTemplate
        workingEnvironmentTopic
        workingEnvironmentTopicTemplate
      }
    }`,
    };
    
    return axios.post(url, graphQuery, HopexApi.getBaseConfig(credentials));
  };

  public static getDiagrams = (
    credentials: IHopexCredentials
  ): Promise<AxiosResponse<IDiagramsGraphResponse>> => {
    const url = `${credentials.serverUrl}${(!credentials.serverUrl.endsWith('/') ? '/' : '')}${apiITPM}`;
    const graphQuery = {
      query: `{
        diagram {
          name(nameSpace:LONG)
          downloadUrl
          id
        }
      }`,
    };

    return axios.post(url, graphQuery, HopexApi.getBaseConfig(credentials));
  };

  public static getDiagram = (
    credentials: IHopexCredentials,
    id: string
  ): Promise<AxiosResponse<IDiagramsGraphResponse>> => {
    const url = `${credentials.serverUrl}${(!credentials.serverUrl.endsWith('/') ? '/' : '')}${apiITPM}`;
    const graphQuery = {
      query: `{
        diagram (filter:{id:"${id}"}) {
            id
            name(nameSpace:LONG)
            downloadUrl
        }
    }`,
    };
    
    return axios.post(url, graphQuery, HopexApi.getBaseConfig(credentials));
  };

  public static getDiagramPicture = (
    credentials: IHopexCredentials,
    downloadUrl: string,
    accept: "image/png" | "image/jpeg" | "image/svg+xml"
  ): Promise<AxiosResponse> => {
    const url = `${credentials.serverUrl}${(!credentials.serverUrl.endsWith('/') ? '/' : '')}HOPEXGraphQL${downloadUrl}`;
    const config = HopexApi.getBaseConfig(credentials);
    config.headers.responseType = "arraybuffer";
    config.headers.accept = accept;

    return axios.get(url, config);
  };
}
